<!-- components/DevBreakpointIndicator.vue -->
<template>
  <div
    v-if="isDev"
    class="fixed bottom-4 left-4 z-[9999] bg-black/80 text-white text-xs font-mono px-3 py-2 rounded-lg shadow-lg pointer-events-none"
  >
    <span class="sm:hidden">xs</span>
    <span class="hidden sm:inline md:hidden">sm</span>
    <span class="hidden md:inline lg:hidden">md</span>
    <span class="hidden lg:inline xl:hidden">lg</span>
    <span class="hidden xl:inline 2xl:hidden">xl</span>
    <span class="hidden 2xl:inline">2xl</span>
    <span class="ml-2 opacity-60">{{ width }}px</span>
  </div>
</template>

<script setup lang="ts">
const isDev = import.meta.dev

const width = ref(0)

onMounted(() => {
  width.value = window.innerWidth

  const handleResize = () => {
    width.value = window.innerWidth
  }

  window.addEventListener('resize', handleResize)

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
  })
})
</script>
